import React from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { groupInformationForm } from "../../../shared/formObjects/application/groupInformationForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function GroupInformationComponent({ disabled, data }: any) {
  const formApi = useApiClient("GroupInformation");
  const { id } = useApplicationContext();

  function getInitalValues(initialData: any) {
    const daysOfTheWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    daysOfTheWeek.map((value) => {
      if (initialData.groupInformationWeeklyData[value] == undefined) {
        initialData.groupInformationWeeklyData[value] = {
          childrenAttendance: "",
          doesChildAttend: false,
          groupNames: "",
          endTime: null,
          startTime: null,
        };
      }
    });
  }

  return (
    <>
      <BaseApplicationComponent
        formBody={groupInformationForm}
        headerLabel="Group Information"
        editPath="groupInformation"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        showInternalNotes={false}
        id={id}
        print={true}
        getInitialValues={getInitalValues}
      />
    </>
  );
}
